import { ThrowError } from "@/api/callApi"
import type { TableColumn } from "@/components/common/CommonTable"
import CommonTable from "@/components/common/CommonTable"
import MainHeading from "@/components/common/MainHeading"
import { DepartmentService } from "@/services/Department/Department"
// import { RoutesLink } from "@/utility/RouteLinks"
import Layout from "@/components/layout/Layout"
import { Pencil, Plus, Trash, TriangleAlert } from "lucide-react"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import type { department } from "@/interface/department.interface"
import { RoutesLink } from "@/utility/RouteLinks"
import { showToastNotification } from "@/utility/helper"
import { Button } from "@/components/ui/button"
import CommonModal from "@/components/common/CommonModal"
import CommonFilter from "@/components/common/CommonFilter"

const Department: React.FC = () => {
    const navigate = useNavigate()
    const [department, setDepartment] = useState<department[]>([]);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [deleteId, setDeleteId] = useState<string>("");
    console?.log("department", department)

    const handleGetDepartment = async () => {
        try {
            const response = await DepartmentService?.getDepartment();
            if (response?.status) {
                setDepartment(response?.data?.department)
                // setDepartment(Array.isArray(response.data) ? response.data : []);
            }
            console.log("response", response)
        } catch (error) {
            ThrowError(error)
        }
    }


    const handleDeleteDepartment = async () => {
        try {
            const response = await DepartmentService?.deleteDepartment(deleteId);
            if (response?.status) {
                showToastNotification("success", response?.message)
                toggleDeleteDialog("")
                handleGetDepartment();
            } else {
                showToastNotification("danger", response?.message)
            }
        } catch (error) {
            ThrowError(error)
        }
    }
    useEffect(() => {
        handleGetDepartment();
    }, []);

    const toggleDeleteDialog = (id: string | undefined) => {
        setDeleteId(id ?? "");
        setDeleteDialogOpen(!deleteDialogOpen);
    }
    const columns: TableColumn<department>[] = [
        {
            key: 'srNo',
            header: 'Sr No',
            render: (_item: department, index: number) => (
                <span className="text-muted-foreground font-medium"># {index + 1}</span>
            )
        },
        {
            key: 'departmentName',
            header: 'Department Name',
            render: (item: department) => (
                <span className="font-semibold capitalize">{item?.name}</span>
            )
        },
        {
            key: 'status',
            header: 'Status',
            render: (item: department) => (
                <span className={`inline-flex items-center px-2 py-0.5 text-xs font-medium border rounded-full ${item?.isActive ? 'text-green-600 border-green-600 bg-green-50' : 'text-destructive border-destructive bg-destructive/10'}`}>
                    {item?.isActive ? 'Active' : 'Inactive'}
                </span>
            )
        },
        {
            key: 'actions',
            header: 'Actions',
            render: (item: department) => (
                <div className="flex gap-2">
                    <Button
                        size={'icon'}
                        onClick={() => navigate(`${RoutesLink.editDepartment}/${item?.id}`)}
                        className="bg-primary/10 text-primary hover:bg-primary/20"
                        title="Edit Department"
                    >
                        <Pencil size={18} />
                    </Button>
                    <Button
                        size={'icon'}
                        onClick={() => toggleDeleteDialog(item?.id)}
                        className="bg-destructive/10 text-destructive hover:bg-destructive/20"
                        title="Delete Department"
                    >
                        <Trash size={18} />
                    </Button>
                </div>
            ),
        },
    ]

    return (
        <>
            <Layout>
                <div className='space-y-6'>
                    <MainHeading
                        title='Department'
                        buttonText='Add Department'
                        buttonIcon={<Plus />}
                        onClick={() => { navigate(RoutesLink.addDepartment) }}
                    />
                    <CommonFilter />
                    <CommonTable data={department} columns={columns} />

                </div>
            </Layout>
            <CommonModal
                title=""
                show={deleteDialogOpen}
                onClose={() => toggleDeleteDialog("")}
                className="max-w-md rounded-2xl p-0 overflow-hidden"
            >
                <div className="p-6">
                    <div className="flex flex-col items-center text-center">
                        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
                            <TriangleAlert className="text-red-600 w-8 h-8" />
                        </div>

                        <h2 className="mt-5 text-2xl font-bold text-gray-900">
                            Delete Department?
                        </h2>

                        <p className="mt-3 text-sm leading-6 text-gray-500">
                            This action cannot be undone. Once deleted, all department data will be
                            permanently removed from our servers.
                        </p>
                    </div>

                    <div className="mt-8 flex gap-3">
                        <Button
                            variant="outline"
                            className="flex-1"
                            onClick={() => toggleDeleteDialog("")}
                        >
                            Cancel
                        </Button>

                        <Button
                            variant="destructive"
                            className="flex-1"
                            onClick={handleDeleteDepartment}
                        >
                            Delete
                        </Button>
                    </div>
                </div>
            </CommonModal>
        </>
    )
}

export default Department